<!-- <div id="product-meta" class="product-meta">
    <div class="row">
        <div class="col-12 col-md-6 product-gallery prodRight">
            <div class="prodImg">
                <ng-container *ngIf="pdtImages.length > 0">
                    <div style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff" class="prodSlide">
                        <div class="swiper-wrapper">
                            <ng-container *ngFor="let item of pdtImages; index as i;">
                                <div class="swiper-slide">
                                    <img [src]="urlWownet + item.filePath + item.fileName" alt="">
                                </div>
                            </ng-container>                           
                        </div>
                    </div>
                    <div thumbsSlider="" class="prodThumb">
                        <div class="swiper-wrapper justify-content-center">
                            <ng-container *ngFor="let item of pdtImages; index as i;">
                                <div class="swiper-slide">
                                    <img [src]="urlWownet + item.filePath + item.fileName" alt="">
                                </div>
                            </ng-container>                           
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="pdtImages.length === 0">
                    <img src="./assets/img/noImage.jpg">
                </ng-container>
            </div>   
        </div>        
        <div class="col-md product-info">
            <h2 class="h-large product-name">{{ pdtInfo.pdtName }}</h2>
            <div class=" row my-3">
                <div class="row">
                    <ng-container *ngIf="isMatchDate(pdtInfo.recomnSDate , pdtInfo.recomnEDate)">
                        <span class="mark-best">BEST</span>
                    </ng-container>
                    <ng-container *ngIf="isMatchDate(pdtInfo.newSDate , pdtInfo.newEDate)">
                        <span class="mark-new">NEW</span>
                    </ng-container>
                    <ng-container *ngIf="isMatchDate(pdtInfo.eventSDate , pdtInfo.eventEDate)">
                        <span class="mark-sale">SALE</span>
                    </ng-container>
                </div>
            </div>
            <div class="basic-infos">
            </div>
            <div class="product-basic row h-false">
                <span class="product-id col-auto">Item # {{ pdtInfo.pdtCd }}</span>
                <span class="product-option-1 col-auto">{{ pdtInfo.option1 }}</span>
            </div>
        <ng-container *ngIf="isLogined">
           <div class="price">
                <div class="row prices">
                    <div class="col-auto type price">
                        <ng-container >
                            <span class="col-auto new-price">
                                {{ 'currency'| translate: { param: pdtInfo.retailAmt | cusprice: pdtInfo.amt | setComma:'price':'' } }}
                            </span>
                        </ng-container>
                    </div>
                </div>
                <div class="row pvs" *ngIf="userKind != '00'">
                    <p class="col-auto type pv" *ngIf="isPv1">
                        {{ pdtInfo.pv1 | setComma: '':'' }}{{ smWowWord.oPv1 }}
                    </p>
                    <p class="col-auto type pv" *ngIf="isPv2">
                        {{ pdtInfo.pv2 | setComma: '':'' }}{{ smWowWord.oPv2 }}
                    </p>
                    <p class="col-auto type pv" *ngIf="isPv3">
                        {{ pdtInfo.pv3 | setComma: '':'' }}{{ smWowWord.oPv3 }}
                    </p>
                    <p class="col-auto type pv" *ngIf="isPoint">
                        {{ pdtInfo.point | setComma: '':'' }}{{ smWowWord.oMileage }}
                    </p>
                    <p class="col-auto type pv" *ngIf="!isPv1&&!isPv2&&!isPv3">
                        0PV
                    </p>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="!isLogined">
                <div class="price" *ngIf="isRetailAmt">
                    <div class="row prices">
                        <div class="col-auto type price">
                            <ng-container>
                                <span class="col-auto new-price">
                                    {{ 'currency'| translate: { param: pdtInfo.retailAmt | setComma:'price':'' } }}
                                </span>
                            </ng-container>
                        </div>
                    </div>
                </div> 

            <div class="price" *ngIf="isAmt">
                 <div class="row prices">
                     <div class="col-auto type price">                 
                         <span class="col-auto new-price">
                                 {{ 'currency'| translate: { param: pdtInfo.amt | setComma:'price' :''} }}
                         </span>  
                     </div>
                 </div>
                 <div class="row pvs">
                     <p class="col-auto type pv" *ngIf="isPv1">
                         {{ pdtInfo.pv1 | setComma: '':'' }}{{ smWowWord.oPv1 }}
                     </p>
                     <p class="col-auto type pv" *ngIf="isPv2">
                         {{ pdtInfo.pv2 | setComma: '':'' }}{{ smWowWord.oPv2 }}
                     </p>
                     <p class="col-auto type pv" *ngIf="isPv3">
                         {{ pdtInfo.pv3 | setComma: '' :''}}{{ smWowWord.oPv3 }}
                     </p>
                     <p class="col-auto type pv" *ngIf="isPoint">
                         {{ pdtInfo.point | setComma: '':'' }}{{ smWowWord.oMileage }}
                     </p>
                     <p class="col-auto type pv" *ngIf="!isPv1&&!isPv2&&!isPv3">
                         0PV
                     </p>
                 </div>
             </div>
         </ng-container>
         <div class="mb-2 row mb-2 p-3 wrap-price justify-content-between">
            <div class="col-auto quantity-input row">
                <div class="cal-btn minus col-auto my-2" (click)="handleOnClickMinus();"
                    [ngClass]="{'disable-btn': isDisableBuying}">
                    <img src="./assets/img/icons/quantity-minus.svg">
                </div>
                <div class="value col-auto my-2">
                    <span id="qty">{{ quantity | setComma :'':''}}</span>
                </div>
                <div class="cal-btn plus col-auto my-2" (click)="handleOnClickPlus();" [ngClass]="{'disable-btn': isDisableBuying}">
                    <img src="./assets/img/icons/quantity-plus.svg">
                </div>
            </div>
            <div class="col-auto align-content-center">
                <div class=" prices">
                    <div class="col-auto type price">
                        <ng-container >
                            <span class="col-auto new-price">
                                {{ 'currency'| translate: { param: total | setComma:'price':'' } }}
                            </span>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

            <div class="basic-infos">
                
            </div>

            <div class="function row">
               
                <a href="javascript:;" class="w-btn col outline-btn add-to-cart-btn" (click)="handleOnClickAddToCart();"
                    [ngClass]="{'disable-btn': isDisableBuying}">
                    <span>{{ 'shopping-mall.home.lbl.019' | translate }}</span>
                </a>
                <a href="javascript:;" class="w-btn col prime-btn checkout-btn" id="checkout"
                    (click)="handleOnClickBuyNow();" [ngClass]="{'disable-btn': isDisableBuying}">
                    <span>{{ 'shopping-mall.home.lbl.018' | translate }}</span>
                </a>
            </div>

           
        </div>
    </div>
</div> -->
<div class="prodDeTop row">
    <div class="col-12 col-md-6 pd0">
        <div class="prodImg">
            <ng-container *ngIf="pdtImages.length > 0">
                <div style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff" class="prodSlide">
                    <div class="swiper-wrapper">
                        <ng-container *ngFor="let item of pdtImages; index as i;">
                            <div class="swiper-slide"><img [src]="urlWownet + item.filePath + item.fileName" alt="">
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div thumbsSlider="" class="prodThumb">
                    <div class="swiper-wrapper">
                        <ng-container *ngFor="let item of pdtImages; index as i;">
                            <div class="swiper-slide"><img [src]="urlWownet + item.filePath + item.fileName" alt="">
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="pdtImages.length === 0">
                <img src="./assets/img/noImage.jpg">
            </ng-container>
        </div>
    </div>
    <div class="col-12 col-md-6 prodRight">
        <div class="prodTit">
            <h2>{{ pdtInfo.pdtName }}</h2>
            <div class="prodTag">
                <ng-container *ngIf="isMatchDate(pdtInfo.recomnSDate , pdtInfo.recomnEDate)">
                    <span class="mark-best">BEST</span>
                </ng-container>
                <ng-container *ngIf="isMatchDate(pdtInfo.newSDate , pdtInfo.newEDate)">
                    <span class="mark-new">NEW</span>
                </ng-container>
                <ng-container *ngIf="isMatchDate(pdtInfo.eventSDate , pdtInfo.eventEDate)">
                    <span class="mark-sale">SALE</span>
                </ng-container>
            </div>
        </div>
        <div class="prodInfo">
            <ng-container *ngIf="isLogined">
                <!-- <ng-container *ngIf="userKind == '00'">
                    <dl class="memberPrice">
                        <dt>소비자가</dt>
                        <dd>{{ 'currency'| translate: { param: pdtInfo.retailAmt | setComma:'price':'' } }}</dd>
                    </dl>
                </ng-container> -->
                <ng-container>
                    <dl class="consuPrice">
                        <dt></dt>
                        <dd *ngIf="+pdtInfo.retailAmt > 0">{{ 'currency'| translate: { param: pdtInfo.retailAmt | setComma:'price':'' } }}</dd>
                    </dl>
                    <dl class="memberPrice">
                        <dt>회원가</dt>
                        <dd>
                            {{ 'currency'| translate: { param: pdtInfo.retailAmt | cusprice: pdtInfo.amt |
                            setComma:'price':'' } }}
                            <span *ngIf="+pdtInfo.rate > 0">{{pdtInfo.rate}}%</span>
                        </dd>
                    </dl>
                    <ng-container *ngIf="userKind != '00'">
                        <dl class="" *ngIf="isPv1">
                            <dt>{{ smWowWord.oPv1 }}</dt>
                            <dd>
                                {{ pdtInfo.pv1 | setComma: '':'' }}{{ smWowWord.oPv1 }}
                            </dd>
                        </dl>
                        <!-- <dl class="" *ngIf="isPv2">
                            <dt>{{ smWowWord.oPv2 }}</dt>
                            <dd>
                                {{ pdtInfo.pv2 | setComma: '':'' }}{{ smWowWord.oPv2 }}
                            </dd>
                        </dl> -->
                        <dl class="" *ngIf="isPv3">
                            <dt>{{ smWowWord.oPv3 }}</dt>
                            <dd>
                                {{ pdtInfo.pv3 | setComma: '':'' }}{{ smWowWord.oPv3 }}
                            </dd>
                        </dl>
                        <dl class="" *ngIf="isPoint">
                            <dt>{{ smWowWord.oMileage }}</dt>
                            <dd>
                                {{ pdtInfo.point | setComma: '':'' }}{{ smWowWord.oMileage }}
                            </dd>
                        </dl>
                    </ng-container>
                </ng-container>
                <dl class="prodDeli">
                    <dt>배송비</dt>
                    <dd>3,000원
                        <p>(6만원 이상 구매시 무료배송)</p>
                    </dd>
                </dl>
            </ng-container>

            <ng-container *ngIf="!isLogined">
                <dl class="memberPrice" *ngIf="isRetailAmt">
                    <dt>소비자가</dt>
                    <dd>{{ 'currency'| translate: { param: pdtInfo.retailAmt | setComma:'price':'' } }}</dd>
                </dl>
                <ng-container *ngIf="isAmt">
                    <dl class="memberPrice">
                        <dt>회원가</dt>
                        <dd>
                            {{ 'currency'| translate: { param: pdtInfo.retailAmt | cusprice: pdtInfo.amt |
                            setComma:'price':'' } }}
                            <span *ngIf="+pdtInfo.rate > 0">{{pdtInfo.rate}}%</span>
                        </dd>
                    </dl>
                    <dl class="" *ngIf="isPv1">
                        <dt>{{ smWowWord.oPv1 }}</dt>
                        <dd>
                            {{ pdtInfo.pv1 | setComma: '':'' }}{{ smWowWord.oPv1 }}
                        </dd>
                    </dl>
                    <dl class="" *ngIf="isPv2">
                        <dt>{{ smWowWord.oPv2 }}</dt>
                        <dd>
                            {{ pdtInfo.pv2 | setComma: '':'' }}{{ smWowWord.oPv2 }}
                        </dd>
                    </dl>
                    <dl class="" *ngIf="isPv3">
                        <dt>{{ smWowWord.oPv3 }}</dt>
                        <dd>
                            {{ pdtInfo.pv3 | setComma: '':'' }}{{ smWowWord.oPv3 }}
                        </dd>
                    </dl>
                    <dl class="" *ngIf="isPoint">
                        <dt>{{ smWowWord.oMileage }}</dt>
                        <dd>
                            {{ pdtInfo.point | setComma: '':'' }}{{ smWowWord.oMileage }}
                        </dd>
                    </dl>
                </ng-container>
                <dl class="prodDeli">
                    <dt>배송비</dt>
                    <dd>3,000원
                        <p>(6만원 이상 구매시 무료배송)</p>
                    </dd>
                </dl>
            </ng-container>
            <!-- <dl class="prodDeli">
                <dt>배송비</dt>
                <dd>
                    3,500원
                    <p>(3만원 이상 구매시 무료배송)</p>
                </dd>
            </dl> -->
        </div>
        <div class="mobiWrap">
            <!-- <a class="mobiProdHide d-md-none">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
            </a> -->
            <div class="prodOption d-md-block d-sm-none d-none">
                <div class="optionCont">
                    <h2>{{ pdtInfo.pdtName }}</h2>
                    <div class="row">
                        <div class="col-6 optionNum">
                            <a (click)="handleOnClickMinus();">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </a>
                            <input type="text" [value]="quantity | setComma :'':''" readonly>
                            <a (click)="handleOnClickPlus();" [ngClass]="{'disable-btn': isDisableBuying}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </a>
                        </div>
                        <div class="col-6 price" *ngIf="!isLogined && isRetailAmt">
                            {{ 'currency'| translate: { param: pdtInfo.retailAmt | cusprice: pdtInfo.amt |
                            setComma:'price':'' } }}
                        </div>
                        <div class="col-6 price" *ngIf="isLogined">
                            {{ 'currency'| translate: { param: pdtInfo.retailAmt | cusprice: pdtInfo.amt |
                            setComma:'price':'' } }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row prodTotal justify-content-between">
                <div class="col-auto d-flex justify-content-between">
                    <div class="col-auto align-self-center">총 합계금액</div>
                    <div class="col-6 optionNum d-md-none d-sm-block">
                        <div class="d-flex">
                            <a (click)="handleOnClickMinus();" class="btn-plus">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </a>
                            <input type="text" [value]="quantity | setComma :'':''" readonly class="input-amount">
                            <a (click)="handleOnClickPlus();" [ngClass]="{'disable-btn': isDisableBuying}"
                                class="btn-minus">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-4 col-4 price text-right" *ngIf="!isLogined && isRetailAmt">
                    {{ 'currency'| translate: { param: total | setComma:'price':'' } }}
                </div>
                <div class="col-md-6 col-sm-4 col-4 price text-right" *ngIf="isLogined">
                    {{ 'currency'| translate: { param: total | setComma:'price':'' } }}
                </div>
            </div>
            <div class="prodBtns">
                <a (click)="onClickWishList($event)" class="addWish">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.18 39.21">
                        <defs>
                            <style>
                                .cls-1 {
                                    fill: none;
                                    stroke: #fff;
                                    stroke-linecap: round;
                                    stroke-linejoin: round;
                                    stroke-width: 2.5px;
                                }

                                .cls-2 {
                                    fill: #fff;
                                }
                                .cls-3 {
                                    fill: #D28FBF;
                                    stroke: #fff;
                                    stroke-linecap: round;
                                    stroke-linejoin: round;
                                    stroke-width: 2.5px;
                                }
                            </style>
                        </defs>
                        <g id="레이어_2" data-name="레이어 2">
                            <g id="image">
                                <path [ngClass]="wishYn == 'Y' ? 'cls-3' : 'cls-1'"
                                    d="M43.93,12.79A11.53,11.53,0,0,0,22.59,6.71,11.54,11.54,0,1,0,4.7,21L22.59,38,40.49,21A11.51,11.51,0,0,0,43.93,12.79Z" />
                                <path class="cls-t"
                                    d="M32.72,7.69A1.53,1.53,0,0,0,33,7.63l-.14,0h.4c.34,0-.2-.06,0,0l.57.15.22.08c.2.07-.26-.13.06,0a5.18,5.18,0,0,1,.57.31L35,8.4s.36.29.09.06a9.3,9.3,0,0,1,1,.92l.24.28c-.22-.26,0,.05.07.11s.23.35.34.53l.16.32c0,.06.19.44.06.11.08.22.16.44.22.67a3.38,3.38,0,0,1,.08.34s0,.08,0,.13,0,.05,0-.12c.09.07,0,.59,0,.7s0,.11,0,.17c0-.19,0-.21,0-.07s0,.23-.08.35-.07.23-.11.34,0,.12,0,0a1.3,1.3,0,0,0-.08.17,1.28,1.28,0,0,0,.44,1.71,1.26,1.26,0,0,0,1.71-.45c1.77-3.63-.89-7.79-4.37-9.16a4.25,4.25,0,0,0-2.68-.19,1.25,1.25,0,1,0,.67,2.41Z" />
                            </g>
                        </g>
                    </svg>
                </a>
                <ul>
                    <li><a href="javascript:;" (click)="handleOnClickAddToCart();">장바구니</a></li>
                    <li><a href="javascript:;" (click)="handleOnClickBuyNow();"
                            [ngClass]="{'disable-btn': isDisableBuying}">바로구매</a></li>
                </ul>
            </div>
        </div>
        <!-- <div class="mobiProdBtns d-md-none">
            <a href="#none" class="addWish">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.18 39.21">
                    <defs>
                        <style>.cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}.cls-2{fill:#fff;}</style>
                    </defs>
                    <g id="레이어_2" data-name="레이어 2">
                        <g id="image">
                            <path class="cls-1" d="M43.93,12.79A11.53,11.53,0,0,0,22.59,6.71,11.54,11.54,0,1,0,4.7,21L22.59,38,40.49,21A11.51,11.51,0,0,0,43.93,12.79Z"/>
                            <path class="cls-t" d="M32.72,7.69A1.53,1.53,0,0,0,33,7.63l-.14,0h.4c.34,0-.2-.06,0,0l.57.15.22.08c.2.07-.26-.13.06,0a5.18,5.18,0,0,1,.57.31L35,8.4s.36.29.09.06a9.3,9.3,0,0,1,1,.92l.24.28c-.22-.26,0,.05.07.11s.23.35.34.53l.16.32c0,.06.19.44.06.11.08.22.16.44.22.67a3.38,3.38,0,0,1,.08.34s0,.08,0,.13,0,.05,0-.12c.09.07,0,.59,0,.7s0,.11,0,.17c0-.19,0-.21,0-.07s0,.23-.08.35-.07.23-.11.34,0,.12,0,0a1.3,1.3,0,0,0-.08.17,1.28,1.28,0,0,0,.44,1.71,1.26,1.26,0,0,0,1.71-.45c1.77-3.63-.89-7.79-4.37-9.16a4.25,4.25,0,0,0-2.68-.19,1.25,1.25,0,1,0,.67,2.41Z"/>
                        </g>
                    </g>
                </svg>
            </a>
            <a href="#none" class="optionOpen">구매하기</a>
        </div> -->
    </div>
</div>